import SlimSelect from 'slim-select';
import AirDatepicker from 'air-datepicker';

$(function() {
    const $select = $('select');

    if ($select) {
        $select.each(function (i, e) {
            new SlimSelect({
                select: e,
                settings: {
                    showSearch: false
                }
            })
        });
    }

    const localeEn = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    };

    new AirDatepicker('.gform-datepicker', {
        locale: localeEn,
        dateFormat: 'MM/dd/yyyy'
    });
});

$(document).on('gform_post_render', function () {
    const $select = $('select');

    if ($select) {
        $select.each(function (i, e) {
            new SlimSelect({
                select: e,
                settings: {
                    showSearch: false
                }
            })
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    let mySelect = document.getElementById('jtsSelect');

    if (mySelect) {
        mySelect.addEventListener('change', function () {
            let selectedValue = mySelect.value;
            // Check if a value is selected
            if (selectedValue) {
                // Scroll to the corresponding section
                let targetSection = document.getElementById(selectedValue);
                let fixedHeader = document.getElementsByClassName('js-page-header')[0];

                if (targetSection) {
                    // Calculate the offset, considering the fixed header height
                    var offset = targetSection.offsetTop - fixedHeader.offsetHeight;

                    // Scroll to the section with the adjusted offset
                    window.scrollTo({
                        top: offset,
                        behavior: 'smooth'
                    });
                }
            }
        });
    }
});